import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {COMMA, ENTER, V} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
    selector: 'app-chip-list-edit',
    templateUrl: './chip-list-edit.component.html',
    styleUrls: ['./chip-list-edit.component.scss'],
    standalone: false
})
export class ChipListEditComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl = new UntypedFormControl();
  filteredChips: Observable<string[]>;

  @Input() label: string = 'Label';
  @Input() allChips: string[] = [];
  @Input() disabled: boolean = false;

  chipsValue: Array<string> = [];
  @Input()
  get chips() {
    return this.chipsValue;
  }
  @Output() chipsChange = new EventEmitter();
  set chips(val){
    // if(val == null){
    //   val = [];
    // }
    this.chipsValue = val;
    this.chipsChange.emit(this.chipsValue);
  }

  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor() {
    this.filteredChips = this.chipCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => fruit ? this._filter(fruit) : this.allChips.slice()));
  }

  ngOnInit(): void {
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if(this.chips == null){
      this.chips = [];
    }

    // Add our fruit
    if ((value || '').trim()) {
      this.chips.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.chipCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.chips.indexOf(fruit);

    if (index >= 0) {
      this.chips.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if(this.chips == null){
      this.chips = [];
    }
    this.chips.push(event.option.viewValue);
    this.chipInput.nativeElement.value = '';
    this.chipCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allChips.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }
}
